(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bomm-pdp-pricing"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bomm-pdp-pricing')) {
  customElements.define('bomm-pdp-pricing', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.variants = JSON.parse(this.querySelector('script').textContent);
      this.scope = this.closest('product-info');
      if (!this.scope) return;
      this.refresh = () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.update());
      };
      for (const name of ['change','input','variant:change','product:variant-change','variant:changed']) document.addEventListener(name, this.refresh, {signal:this.controller.signal});
      this.observer = new MutationObserver(this.refresh);
      this.observer.observe(this.scope, {subtree:true,childList:true,attributes:true,attributeFilter:['value','data-current-variant']});
      this.refresh();
    }
    update() {
      const form = this.scope.querySelector('form[data-type="add-to-cart-form"]');
      const id = form?.elements.namedItem('id')?.value;
      const variant = this.variants.find(item => String(item.id) === String(id));
      if (!variant || this.lastId === String(id)) return;
      const root = this.scope.querySelector('[data-bomm-payment-module]');
      if (!root) return;
      this.lastId = String(id);
      const price = Number(variant.price), compare = Number(variant.compare_at_price || 0);
      const transfer = Math.round(price * .95);
      const hasDiscount = compare > price;
      const saving = (hasDiscount ? compare : price) - transfer;
      const amounts = {transfer,saving,installment:Math.round(price/12),downpayment:Math.round(price*.35),balance:price-Math.round(price*.35)};
      const money = cents => '$' + Math.round(cents/100).toLocaleString('es-CL');
      for (const [role,cents] of Object.entries(amounts)) {
        const el = root.querySelector('[data-bomm-payment-role="'+role+'"]');
        if (el) { el.dataset.bommPaymentCents = String(cents); el.textContent = money(cents); }
      }
      const badge = root.querySelector('.bomm-payment-info__discount-badge');
      if (badge) badge.textContent = hasDiscount ? this.dataset.total.replace('{percent}', Math.round((compare-transfer)*100/compare)) : '-5%';
      const savingBox = root.querySelector('.bomm-payment-info__saving');
      if (savingBox) {
        const strong = savingBox.querySelector('strong');
        savingBox.replaceChildren(document.createTextNode((hasDiscount ? this.dataset.combined : this.dataset.saving)+' '), strong);
      }
      const finance = root.querySelector('[data-bomm-finance]');
      if (finance) finance.hidden = price < 100000000;
      const financeLabel = root.querySelector('[data-bomm-finance-label]');
      const cardLabel = root.querySelector('[data-bomm-card-label]');
      if (financeLabel) financeLabel.hidden = price < 100000000;
      if (cardLabel) cardLabel.hidden = price >= 100000000;
      const priceRoot = this.scope.querySelector('[data-bomm-pdp-price]');
      if (priceRoot) {
        priceRoot.dataset.currentVariant = String(id);
        priceRoot.classList.toggle('is-discounted',hasDiscount);
        priceRoot.classList.toggle('is-regular',!hasDiscount);
        const current = priceRoot.querySelector('.bomm-pdp-price__current');
        if (current) { current.textContent=money(price); current.dataset.bommPriceCents=String(price); }
        let old = priceRoot.querySelector('.bomm-pdp-price__compare');
        let discount = priceRoot.querySelector('.bomm-pdp-price__badge');
        if (hasDiscount) {
          if (!old) { old=document.createElement('span'); old.className='bomm-pdp-price__compare'; priceRoot.querySelector('.bomm-pdp-price__row').append(old); }
          old.textContent=money(compare); old.dataset.bommPriceCents=String(compare);
          if (!discount) { discount=document.createElement('div'); discount.className='bomm-pdp-price__badge'; priceRoot.prepend(discount); }
          discount.textContent='-'+Math.round((compare-price)*100/compare)+'%';
        } else { old?.remove(); discount?.remove(); }
      }
    }
    disconnectedCallback() { this.controller?.abort(); this.observer?.disconnect(); cancelAnimationFrame(this.frame); this.controller=null; this.lastId=null; }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bomm-product-advice"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bomm-product-advice')) {
  customElements.define('bomm-product-advice', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.link = this.querySelector('a');
      this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
      const refresh = () => {
        const form = document.getElementById(this.dataset.form);
        const id = form?.elements.namedItem('id')?.value;
        const variant = this.variants.find(item => String(item.id) === String(id));
        const url = new URL(this.link.href);
        for (const key of ['variante','variante_id','sku','cantidad']) url.searchParams.delete(key);
        if (variant) {
          url.searchParams.set('variante_id', String(variant.id));
          if (variant.title !== 'Default Title') url.searchParams.set('variante', variant.title);
          if (variant.sku) url.searchParams.set('sku', variant.sku);
        }
        const quantity = form?.elements.namedItem('quantity')?.value || '1';
        if (/^[1-9]\d{0,5}$/.test(quantity)) url.searchParams.set('cantidad', quantity);
        this.link.href = url.href;
      };
      for (const event of ['click','auxclick','focus','pointerdown']) this.link.addEventListener(event, refresh, {signal:this.controller.signal});
    }
    disconnectedCallback() { this.controller?.abort(); this.controller = null; }
  });
}
  } catch(e) { console.error(e); }
})();

})();
